export default {
  token: {
    method: 'POST',
    uri: '/oauth/token',
  },
  revoke: {
    method: 'POST',
    uri: '/oauth/revoke',
  },
};
